// FullCalendar - Full-sized, drag & drop event calendar in JavaScript: https://fullcalendar.io/

window.FullCalendar = require('@fullcalendar/core/main.js');
window.FullCalendarDayGrid = require('@fullcalendar/daygrid/main.js');
window.FullCalendarGoogleCalendar = require('@fullcalendar/google-calendar/main.js');
window.FullCalendarInteraction = require('@fullcalendar/interaction/main.js');
window.FullCalendarList = require('@fullcalendar/list/main.js');
window.FullCalendarTimeGrid = require('@fullcalendar/timegrid/main.js');
